
export const validateSpanishNifAndNie = value => {
  let validChars = 'TRWAGMYFPDXBNJZSQVHLCKET'
  let nifRexp = /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKET]{1}$/i
  let nieRexp = /^[XYZ]{1}[0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKET]{1}$/i
  let str = value.toString().toUpperCase()
  if (!nifRexp.test(str) && !nieRexp.test(str)) return false
  let nie = str
    .replace(/^[X]/, '0')
    .replace(/^[Y]/, '1')
    .replace(/^[Z]/, '2')

  let letter = str.substr(-1)
  var charIndex = parseInt(nie.substr(0, 8)) % 23
  if (validChars.charAt(charIndex) === letter) return true

  return false
}

export const latinAlpha = (value) => /^[^0-9!<>,;?=+()@#"°{}_€$%:]*$/.test(value)
export const latinAlphaNumeric = value => /^[^!<>,;?=+()@#"°{}_€$%:]*$/.test(value)

export const alphaNumSpace = (value) => /^[\w\-\s]+$/.test(value)

export const COUNTRY_VALIDATION_LIST = [
  {
    id: 1,
    isoCode: 'ES',
    mask: 'X#######A',
    validationRule: validateSpanishNifAndNie
  },
  {
    id: 2,
    isoCode: 'PT',
    mask: '',
    validationRule: latinAlphaNumeric
  },
  {
    id: 3,
    isoCode: 'US',
    mask: '',
    validationRule: latinAlphaNumeric

  },
  {
    id: 4,
    isoCode: 'MEX',
    mask: '',
    validationRule: latinAlphaNumeric
  }
]
